import { AuthGuardAdmin } from './shared/security/auth.guard.admin';
import { AuthGuard } from './shared/security/auth.guard';
import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { InstitutionCreateComponent } from './institutions/institution-create/institution-create.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { InstitutionListComponent } from './institutions/institution-list/institution-list.component';
import { InstitutionUpdateComponent } from './institutions/institution-update/institution-update.component';
import { ChoiceResponsibleComponent } from './choice-responsible/choice-responsible.component';
import { ChoiceStudentComponent } from './choice-student/choice-student.component';
import { StudentDashboardComponent } from './student-dashboard/student-dashboard.component';
import { ResponsibleDashboardComponent } from './responsible-dashboard/responsible-dashboard.component';
import { UserCreateComponent } from './users/user-create/user-create.component';
import { UserUpdateComponent } from './users/user-update/user-update.component';

const appRoutes: Routes = [
      { path: '', redirectTo: 'accueil', pathMatch: 'full' },
      { path: 'accueil', component: HomeComponent },
      { path: 'login', component: LoginComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'choice-responsible', component: ChoiceResponsibleComponent, canActivate: [AuthGuardAdmin] },
      { path: 'choice-student', component: ChoiceStudentComponent, canActivate: [AuthGuard] },
      { path: 'student-dashboard', component: StudentDashboardComponent },
      { path: 'responsible-dashboard', component: ResponsibleDashboardComponent },
      { path: 'institution-create', component: InstitutionCreateComponent },
      { path: 'institution-list', component: InstitutionListComponent },
      { path: 'institution-update', component: InstitutionUpdateComponent },
      { path: 'user-create', component: UserCreateComponent },
      { path: 'user-update', component: UserUpdateComponent },
      { path: '**', redirectTo: 'home' }
];

export const appRoutingProviders: any[] = [ ];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/app.routing.ts